import Vue from 'vue'
import App from './App.vue'
import VueApollo from "vue-apollo";

import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
} from "apollo-boost";

import router from './router'


Vue.use(VueApollo);
export const apolloClient = new ApolloClient({
  link: new HttpLink({  uri: 'https://api-eu-central-1.graphcms.com/v2/ckd6rnh441dhx01wa9wesge0n/master'}),
  cache: new InMemoryCache()
});


const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

Vue.config.productionTip = false

new Vue({
  apolloProvider,
  router,
  render: h => h(App)
}).$mount('#app')
